import { cn } from '../../lib/cn';
import type { GoLiveReadinessRow } from '../../enterpriseacceptance/framework';

type Props = { artifacts?: GoLiveReadinessRow[] };

export function GoLiveReadinessPanel({ artifacts = [] }: Props) {
  return (
    <div className="space-y-2">
      {artifacts.map((a) => (
        <div key={a.artifact} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{a.artifact}</p>
              <p className="text-xs text-slate-500">{a.owner}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              a.status === 'complete' || a.status === 'current' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              a.status === 'draft' ? 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400' :
              'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {a.status.replace('_', ' ')} · {a.progress}%
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', a.progress === 100 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${a.progress}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
